import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Company } from '@types'

import { PopUp } from '@components/PopUp'
import { Input } from '@components/Input'

import { TextArea } from '@components/TextArea'

import { useCreateCompany } from '@hooks/company/create-company.hook'

import { Container } from './PopUpAddCompany.styled'

interface Props {
  projectId: string
  onAdd: (company: Company) => void
  onClose: () => void
}

export const PopUpAddCompany = (props: Props): JSX.Element => {
  const { projectId, onAdd, onClose } = props

  const { t } = useTranslation()

  const [name, setName] = useState<string>('')
  const [siren, setSiren] = useState<string>('')
  const [description, setDescription] = useState<string>('')

  const { createCompany } = useCreateCompany()

  return (
    <PopUp
      title={t('modules_shared_components_PopAddCompany_title')}
      onSubmitLabel={t('modules_shared_components_PopAddCompany_button_add_company')}
      onClose={onClose}
      onSubmit={async () => {
        if (projectId) {
          const company = await createCompany({
            projectId,
            name,
            siren,
            description,
          })

          if (company) {
            onAdd(company)
          }
        }

        onClose()
      }}
    >
      <Container>
        <Input
          autoFocus
          required
          label={t('modules_shared_components_PopAddCompany_label_company_name')}
          placeholder={t('modules_shared_components_PopAddCompany_placeholder_company_name')}
          value={name}
          onChange={(v) => setName(v)}
        />
        <Input
          label={t('modules_shared_components_PopAddCompany_label_company_siren')}
          placeholder={t('modules_shared_components_PopAddCompany_placeholder_company_siren')}
          value={siren}
          onChange={(v) => setSiren(v)}
        />
        <TextArea
          label={t('modules_shared_components_PopAddCompany_label_description')}
          placeholder={t('modules_shared_components_PopAddCompany_placeholder_description')}
          value={description}
          onChange={(v) => setDescription(v)}
        />
      </Container>
    </PopUp>
  )
}
